module.exports = __webpack_public_path__ + "assets/img/iso_20000_light.fae2bb60.png";